// Shared hook: returns `true` when the site footer is in (or near) the viewport.
// Used by the sticky bottom CTAs so they auto-hide and never cover footer links
// (Impressum / Datenschutz / AGB / Social etc.).
import { useEffect, useState } from "react";

export function useFooterVisible(rootMargin = "0px 0px 120px 0px") {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = document.getElementById("site-footer");
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setVisible(!!entry && entry.isIntersecting);
      },
      { root: null, rootMargin, threshold: 0 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [rootMargin]);

  return visible;
}
